import React from 'react';
import styled, { css } from 'styled-components';
import { textGray } from '../utils/colors';
import { Button } from './CommonUiComponents';

const StyledNoAccess = styled.div`
  position: fixed;
  color: ${textGray};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: ${props => props.theme.primary};
  z-index: 15;
  padding: 3rem;
  text-align: center;

  h1 {
    margin-bottom: 0rem;
  }

  p {
    font-size: 1.25rem;

    ${props =>
      props.inverted &&
      css`
        color: #ffffff;
      `};
  }

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

class NoAccess extends React.Component {
  render() {
    const { logout, invertedTheme } = this.props;

    return (
      <StyledNoAccess inverted={invertedTheme}>
        <h1>Du har ikke tilgang til denne boken!</h1>
        <p>Registrer en ny lisensnøkkel for å få tilgang</p>
        <Button onClick={logout}>Logg ut</Button>
      </StyledNoAccess>
    );
  }
}

export default NoAccess;



// WEBPACK FOOTER //
// ./src/components/NoAccess.js